"use client";

import { Button } from "@app/components/Dashboard/dashboard/ui/button";
import {
  Calendar,
  PopoverContent,
  PopoverTrigger,
  Popover,
} from "@shortsworks/ui";
import * as React from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { useState } from "react";

interface DatePickerProps {
  onChange: (payload: { startDate: Date; endDate: Date }) => void;
  startDate?: Date;
  endDate?: Date;
}

export function DatePicker({
  onChange,
  startDate: initialStartDate,
  endDate: initialEndDate,
}: DatePickerProps) {
  const [startDate, setStartDate] = useState(initialStartDate);
  const [endDate, setEndDate] = useState(initialEndDate);

  const handleSelect = (range: any) => {
    if (range?.from) {
      setStartDate(range.from);
    }
    if (range?.to) {
      setEndDate(range.to);
    }

    if (range?.from && range?.to) {
      onChange({
        startDate: range?.from,
        endDate: range?.to,
      });
    }
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          style={{
            width: "280px",
            justifyContent: "flex-start",
            textAlign: "left",
            fontWeight: "normal",
          }}
        >
          <CalendarIcon
            className="mr-2 h-4 w-4"
            style={{ marginRight: "0.5rem", width: "1rem", height: "1rem" }}
          />
          {startDate && format(startDate, "yyyy-MM-dd")}
          {endDate && format(endDate, "~ yyyy-MM-dd")}
          {!startDate && !endDate && <span>기간을 설정하세요</span>}
          {/*{startDate && endDate && ` (${Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24))} days)`}*/}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-auto p-0"
        style={{ width: "auto", padding: 0 }}
      >
        <Calendar
          mode="range"
          selected={{
            from: startDate,
            to: endDate,
          }}
          onSelect={handleSelect}
          initialFocus
          numberOfMonths={2}
        />
      </PopoverContent>
    </Popover>
  );
}
